var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18.5,
    viewBox: "0 0 22 18.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#666}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "menu_icon",
    transform: "translate(-33 -27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_37",
    width: 22,
    height: 2.5,
    className: "cls-1",
    rx: 1.25,
    transform: "translate(33 27)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    width: 22,
    height: 2.5,
    className: "cls-1",
    rx: 1.25,
    transform: "translate(33 35)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    width: 22,
    height: 2.5,
    className: "cls-1",
    rx: 1.25,
    transform: "translate(33 43)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/menu_icon.dbf8f0e7.svg";
export { ForwardRef as ReactComponent };